import {ChartType} from 'common/report/constants';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';

import BOARDS_IMAGE from './images/report-types/boards.svg';
import FLOWS_IMAGE from './images/report-types/flows.svg';
import FUNNELS_IMAGE from './images/report-types/funnels.svg';
import INSIGHTS_IMAGE from './images/report-types/insights.svg';
import RETENTION_IMAGE from './images/report-types/retention.svg';
import FLOWS_SANKEY_IMAGE from './images/chart-types/flows-sankey.svg';
import FLOWS_TOP_PATHS_IMAGE from './images/chart-types/flows-top-paths.svg';
import FUNNEL_FREQUENCY_IMAGE from './images/chart-types/funnel-frequency.svg';
import FUNNEL_STEPS_IMAGE from './images/chart-types/funnel-steps.svg';
import FUNNEL_TOP_PATHS_IMAGE from './images/chart-types/funnel-top-paths.svg';
import FUNNEL_TRENDS_IMAGE from './images/chart-types/funnel-trends.svg';
import FUNNEL_TTC_IMAGE from './images/chart-types/funnel-ttc.svg';
import IMPACT_IMAGE from './images/report-types/impact.svg';
import INSIGHTS_BAR_IMAGE from './images/chart-types/insights-bar.svg';
import INSIGHTS_LINE_IMAGE from './images/chart-types/insights-line.svg';
import INSIGHTS_METRIC_IMAGE from './images/chart-types/insights-metric.svg';
import INSIGHTS_PIE_IMAGE from './images/chart-types/insights-pie.svg';
import INSIGHTS_STACKED_BAR_IMAGE from './images/chart-types/insights-stacked-bar.svg';
import INSIGHTS_STACKED_LINE_IMAGE from './images/chart-types/insights-stacked-line.svg';
import INSIGHTS_TABLE_IMAGE from './images/chart-types/insights-table.svg';
import RETENTION_CURVE_IMAGE from './images/chart-types/retention-curve.svg';
import RETENTION_TRENDS_IMAGE from './images/chart-types/retention-trends.svg';

export function getDefaultEntityImage(bookmarkType: string = null) {
  switch (bookmarkType) {
    case BookmarkType.Impact:
      return IMPACT_IMAGE;
    case BookmarkType.Funnels:
      return FUNNELS_IMAGE;
    case BookmarkType.Flows:
      return FLOWS_IMAGE;
    case BookmarkType.Insights:
      return INSIGHTS_IMAGE;
    case BookmarkType.Retention:
      return RETENTION_IMAGE;
    default:
      return BOARDS_IMAGE;
  }
}

export function getEntityImage(chartType: ChartType = null, bookmarkType: string = null) {
  switch (chartType) {
    case ChartType.Flows:
    case ChartType.Sankey:
      return FLOWS_SANKEY_IMAGE;
    case ChartType.FlowsTopPaths:
      return FLOWS_TOP_PATHS_IMAGE;
    case ChartType.FunnelFrequencyBar:
    case ChartType.FunnelFrequencyLine:
      return FUNNEL_FREQUENCY_IMAGE;
    case ChartType.FunnelMedianTTC:
    case ChartType.FunnelTTCBar:
    case ChartType.FunnelTTCLine:
      return FUNNEL_TTC_IMAGE;
    case ChartType.FunnelSteps:
    case ChartType.FunnelStepsMetric:
      return FUNNEL_STEPS_IMAGE;
    case ChartType.FunnelTrend:
      return FUNNEL_TRENDS_IMAGE;
    case ChartType.FunnelTopPaths:
      return FUNNEL_TOP_PATHS_IMAGE;
    case ChartType.Bar:
      return INSIGHTS_BAR_IMAGE;
    case ChartType.Line:
      return INSIGHTS_LINE_IMAGE;
    case ChartType.Table:
      return INSIGHTS_TABLE_IMAGE;
    case ChartType.Metric:
    case ChartType.LegacyMetric:
      return INSIGHTS_METRIC_IMAGE;
    case ChartType.StackedBar:
      return INSIGHTS_STACKED_BAR_IMAGE;
    case ChartType.StackedLine:
      return INSIGHTS_STACKED_LINE_IMAGE;
    case ChartType.Pie:
      return INSIGHTS_PIE_IMAGE;
    case ChartType.RetentionLine:
    case ChartType.RetentionTable:
      return RETENTION_CURVE_IMAGE;
    case ChartType.RetentionTrend:
    case ChartType.RetentionTrendMetric:
      return RETENTION_TRENDS_IMAGE;
    default:
      return getDefaultEntityImage(bookmarkType);
  }
}
